
const sideLinks = () => {

	const $btn = $('.side-opener-btn');
	const $body = $('body');
	const _toggleClass = 'side-open';

	$btn.on('click', () => {
		$body.toggleClass(_toggleClass)
	});

}

export { sideLinks }